import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group } from '@mantine/core';
import {
    Button, Col, Form, FormGroup, Row,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';

import NewEntityButton from './NewEntityButton';
import { CheckboxField, InputField } from '../blocks/edit_blocks';
import { TableScreenWithoutUpdate } from '../blocks/table_block';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';
import { buildGameURL } from '../tools/build_urls';
import { formatDateTime } from '../tools/converters';

const API_ENDPOINT = 'games/?';
const DEFAULT_FILTERS = {
    is_draft: false,
};

export default class GameScreen extends React.Component {
    constructor(props) {
        super(props);
        this.filterChange = this.filterChange.bind(this);
        this.filterCleanup = this.filterCleanup.bind(this);
        this.refreshState = this.refreshState.bind(this);
        this.removeItemHandler = this.removeItemHandler.bind(this);
        this.state = {
            filter: DEFAULT_FILTERS,
            results: [],
            previous: 'none',
            next: 'none',
            total_pages: 0,
            current_page: 1,
            API_ENDPOINT_QS: 'is_draft=false',
        };
    }

    refreshState() {
        this.setState({ results: [] });
    }

    removeItemHandler(event) {
        if (window.confirm(`Внимание! Вы действительно хотите удалить ${event.currentTarget.dataset.name || ''}?`)) {
            Fetcher(`games/${event.currentTarget.id}/`, 'DELETE', this.refreshState);
        }
    }

    columns = [
        {
            Header: 'ID',
            accessor: 'id',
            maxWidth: 70,

        }, {
            Header: '',
            accessor: 'slug',
            maxWidth: 40,
            Cell: (row) => (
                <div>
                    <a href={buildGameURL(row.value)} target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon="home" />
                    </a>
                </div>
            ),
        }, {
            Header: 'Название',
            accessor: 'name',
            minWidth: 440,
            Cell: (row) => (
                <div>
                    <Link to={`${PROJECT_PREFIX}/games/${row.row.id}/edit`}>
                        {row.row.name}
                    </Link>
                </div>
            ),
        }, {
            Header: 'Дата добавления',
            accessor: 'date_added',
            maxWidth: 160,
            Cell: (row) => (formatDateTime(row.value)),
        }, {
            Header: 'Дата изменения',
            accessor: 'date_modified',
            maxWidth: 160,
            Cell: (row) => (formatDateTime(row.value)),
        }, {
            Header: 'Дата публикации',
            accessor: 'date_published',
            maxWidth: 160,
            Cell: (row) => (formatDateTime(row.value)),
        }, {
            Header: 'Просм.',
            accessor: 'views',
            maxWidth: 70,
        }, {
            Header: 'Оценка',
            accessor: 'rating',
            maxWidth: 80,
        }, {
            Header: '',
            accessor: 'id',
            maxWidth: 40,
            Cell: (row) => (
                <Button
                    size="sm"
                    variant="link"
                    id={row.value}
                    data-name={row.original.name}
                    onClick={this.removeItemHandler}
                >
                    <FontAwesomeIcon id={row.value} icon="trash" />
                </Button>
            ),
        },
    ];

    filterChange(event) {
        const filter_params = {
            [event.currentTarget.id]: event.currentTarget.value,
        };

        if (event.currentTarget.type === 'checkbox') {
            filter_params[event.currentTarget.id] = event.currentTarget.checked;
        }

        const filter = {
            ...this.state.filter,
            ...filter_params,
        };

        let API_ENDPOINT_QS = '';

        Object.keys(filter).map((key, i) => {
            if (i !== 0) {
                API_ENDPOINT_QS += '&';
            }

            API_ENDPOINT_QS += `${key}=${filter[key]}`;
        });

        this.setState({
            filter,
            API_ENDPOINT_QS,
        });
    }

    filterCleanup() {
        this.setState({
            filter: DEFAULT_FILTERS,
            API_ENDPOINT_QS: 'is_draft=false',
        });
    }

    render() {
        return (
            <div className="container-fluid">
                <Row className="mb-2">
                    <Col md={12}>
                        <NewEntityButton to="/games/new" />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Form inline>
                            <FormGroup>
                                <Group spacing="xs">
                                    <InputField
                                        value={this.state.filter.search || ''}
                                        label="Фильтр"
                                        name="search"
                                        placeholder="Название (=war - точное совпадение, war - поиск по вхождению)"
                                        onChange={this.filterChange}
                                    />
                                    <CheckboxField
                                        name="is_draft"
                                        label="Черновики"
                                        value={this.state.filter.is_draft}
                                        onChange={this.filterChange}
                                    />
                                    <Button variant="outline-secondary" onClick={this.filterCleanup}>
                                        Сбросить
                                    </Button>
                                </Group>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
                <TableScreenWithoutUpdate
                    columns={this.columns}
                    endpoint={API_ENDPOINT + this.state.API_ENDPOINT_QS}
                    data={this.state}
                />
            </div>
        );
    }
}
